export default {
  methods: {
    /* redirect */
    doRedirect() {
      let r = this.$route.query.redirect_url;
      if (r) {
        window.location.href = r;
      } else {
        // MAYBE: use 'push' instead
        this.$router.replace({
          name: "detail"
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/index/utils/mixinRedirect.js